/** Reduz a imagem no navegador antes de enviar (foto de perfil: quadrada, 256px, JPEG) */
export const reduzirFoto = (arquivo, lado = 256) =>
  new Promise((ok, erro) => {
    const img = new Image();
    img.onload = () => {
      const m = Math.min(img.width, img.height);
      const c = document.createElement("canvas");
      c.width = lado; c.height = lado;
      c.getContext("2d").drawImage(img, (img.width - m) / 2, (img.height - m) / 2, m, m, 0, 0, lado, lado);
      URL.revokeObjectURL(img.src);
      ok(c.toDataURL("image/jpeg", 0.85));
    };
    img.onerror = erro;
    img.src = URL.createObjectURL(arquivo);
  });

export const iniciais = (nome) =>
  (nome || "?").trim().split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]).join("").toUpperCase() || "?";
